import { defineMessages } from 'react-intl';

const messages = defineMessages({
  welcomeHeader: {
    id: 'landingPage.welcomeHeader',
    defaultMessage: 'Welcome to the',
    description: 'Welcome header message on the app landing page',
  },
  welcomeBody: {
    id: 'landingPage.welcomeBody',
    defaultMessage: 'Your reliable helper. Simple, fast, done.',
    description: 'Welcome body message on the app landing page',
  },
  loginButton: {
    id: 'landingPage.loginButton',
    defaultMessage: 'Log in',
    description: 'Login button on the app landing page',
  },
  registerButton: {
    id: 'landingPage.registerButton',
    defaultMessage: 'Register / Create AGCO ID',
    description: 'Register button on the app landing page',
  },
});

export default messages;
